<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('Sheet')"></app-page-top-section>

    <div class="card card-with-shadow border-0 p-3" style="min-height: 400px;">
      <div v-if="loading" class="text-center my-5">
        <span>{{ $t('loading') }}...</span>
      </div>

      <div v-else>
        <div v-if="service" class="mb-4">
          <h4 class="mb-3">{{ service.name_en }}</h4>
          <div class="row sheet_data_html " v-html="service.template"></div>
        </div>

        <!-- Payslips Section -->
        <div class="row d-none payslip_data_make" v-if="payslips.length">
  <table id="salaryTable" class="table table-bordered table-sm">
  <thead>
    <tr>
      <th>SL</th>
      <th>Name & Designation</th>
      <th>Joining Date</th>

      <!-- Dynamic Allowance Headers -->
      <th v-for="allowance in allAllowances" :key="allowance">{{ allowance }}</th>

      <th>Gross Salary</th>

      <!-- Dynamic Deduction Headers -->
      <th v-for="deduction in allDeductions" :key="deduction">{{ deduction }}</th>

      <th>Total Deduct</th>
      <th>Net Payment</th>
      <th>Remark</th>
    </tr>
  </thead>
<tbody>
  <tr v-for="(payslip, index) in payslips" :key="payslip.id">
    <td>{{ index + 1 }}</td>
    <td class="text-left">{{ payslip.user.full_name }} - {{ payslip.user.designation.name }}</td>
    <td>{{ new Date(payslip.user.profile.joining_date).toLocaleDateString() }}</td>

      <td v-for="allowance in allAllowances" 
        :key="allowance" 
        class="text-right">
        {{ formatNumber(getBeneficiaryAmount(payslip, allowance)) }}
    </td>

    <td class="text-right">{{ formatNumber(payslip.basic_salary) }}</td>

    <td v-for="deduction in allDeductions" 
        :key="deduction" 
        class="text-right">
        {{ formatNumber(getBeneficiaryAmount(payslip, deduction)) }}
    </td>

    <td class="text-right">{{ formatNumber(getTotalDeduction(payslip)) }}</td>
    <td class="text-right">{{ formatNumber(payslip.net_salary) }}</td>
    <td class="text-left">{{ payslip.payrun.data.note ?? '-' }}</td>
  </tr>
<!-- Total Row -->
<tr style="font-weight:bold; background:#f1f1f1;">
  <td colspan="3" style="text-align:right;">Total Amount</td>

  <!-- Sum of each allowance -->
  <td v-for="allowance in allAllowances" 
      :key="allowance" 
      class="text-right">
    {{ formatNumber(payslips.reduce((sum, p) => sum + getBeneficiaryAmount(p, allowance), 0)) }}
  </td>

  <!-- Sum of Basic Salary -->
  <td class="text-right">
    {{ formatNumber(payslips.reduce((sum, p) => sum + (p.basic_salary || 0), 0)) }}
  </td>

  <!-- Sum of each deduction -->
  <td v-for="deduction in allDeductions" 
      :key="deduction" 
      class="text-right">
    {{ formatNumber(payslips.reduce((sum, p) => sum + getBeneficiaryAmount(p, deduction), 0)) }}
  </td>

  <!-- Sum of total deductions -->
  <td class="text-right">
    {{ formatNumber(payslips.reduce((sum, p) => sum + getTotalDeduction(p), 0)) }}
  </td>

  <!-- Sum of Net Payment -->
  <td class="text-right">
    {{ formatNumber(payslips.reduce((sum, p) => sum + (p.net_salary || 0), 0)) }}
  </td>

  <td></td> <!-- Remark column empty -->
</tr>

</tbody>
</table>
</div>

        

        <!-- No Service Found -->
        <div v-if="!service && payslips.length === 0" class="text-center">
          <span>{{ $t('No service found') }}</span>
        </div>
      </div>
      <div v-if="service" class="text-end">
  <button class="btn btn-success" @click="sendSheet">
    {{ $t('send_for_approval') }}
  </button>
</div>
    </div>
    <div class="mb-3 text-end" v-if="payslips.length">

</div>
  </div>
</template>
<script>
import { PAYSLIP } from "../../../Config/ApiUrl";
import { axiosGet } from "../../../../common/Helper/AxiosHelper";
import { nextTick } from 'vue';

export default {
  name: "Payslip",
  props: { payrun: {} },
  data() {
    return {
      service: null,
      payslips: [],
      loading: false,
      allAllowances: [], // dynamic allowance names
      allDeductions: []  // dynamic deduction names
    };
  },
  created() { this.getServiceWithPayslips(); },
  methods: {
    async getServiceWithPayslips() {
      this.loading = true;
      try {
        const serviceResponse = await axiosGet(`app/services?service_code=HRSS`);
        this.service = serviceResponse.data.data || null;

        if (this.service) {
  const payslipResponse = await axiosGet(`${PAYSLIP}?payrun=${this.payrun}&within=total&per_page=100&orderBy=desc`);
  const data = payslipResponse.data.data || [];

  // extract unique allowances/deductions from payrun.beneficiaries
  let allowances = new Set();
  let deductions = new Set();

  data.forEach(p => {
    if (p.payrun && p.payrun.beneficiaries && p.payrun.beneficiaries.length) {
      p.payrun.beneficiaries.forEach(b => {
        if (b.beneficiary?.type === "allowance") allowances.add(b.beneficiary.name);
        if (b.beneficiary?.type === "deduction") deductions.add(b.beneficiary.name);
      });
    }
  });

  this.allAllowances = Array.from(allowances);
  this.allDeductions = Array.from(deductions);
  this.payslips = data;
}
      } catch (err) {
        console.error(err);
        this.service = null;
        this.payslips = [];
      } finally {
        this.loading = false;
        nextTick(() => {
          $('.payslip_data_view').html($('.payslip_data_make').html());
          const total = this.payslips.reduce((sum, p) => sum + (p.net_salary || 0), 0);
          $('.in_word').html(this.toWords(total));
          if (this.payslips.length > 0) {
            const date = new Date(this.payslips[0].start_date);
            const options = { year: 'numeric', month: 'long' }; // e.g., July 2025
            const monthName = date.toLocaleDateString('en-US', options);
            $('.month_name').html(monthName);
        }
        });
      }
    },
    getBeneficiaryAmount(payslip, name) {
    const b = payslip.payrun.beneficiaries.find(
      x => x.beneficiary?.name === name
    );
    if (!b) return 0;

    if (b.is_percentage) {
      return ((payslip.basic_salary || 0) * b.amount) / 100;
    }
    return b.amount || 0;
  },

  getTotalDeduction(payslip) {
    return payslip.payrun.beneficiaries
      .filter(b => b.beneficiary?.type === 'deduction')
      .reduce((sum, b) => {
        if (b.is_percentage) return sum + ((payslip.basic_salary || 0) * b.amount) / 100;
        return sum + (b.amount || 0);
      }, 0);
  },
  async sendSheet() {
    if (!this.service) return;

    try {
      this.loading = true;

      const htmlData = document.querySelector('.sheet_data_html').innerHTML;

      const payload = {
        payrun: this.payrun,
        service_id: this.service.id,
        html_data: htmlData
      };

      // Send POST request to your Laravel controller
      const response = await axios.post('/app/send-sheet', payload);

    if (response.data.success) {
      Swal.fire({
        icon: 'success',
        title: this.$t('Success'),
        text: response.data.message,
        confirmButtonColor: '#28a745'
      }).then(() => {
        window.location.href = '/payroll/payrun';
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: this.$t('Failed'),
        text: response.data.message,
        confirmButtonColor: '#d33'
      });
    }


    } catch (error) {
      Swal.fire({
      icon: 'error',
      title: this.$t('Error'),
      text: this.$t('Something went wrong while sending the sheet.'),
      confirmButtonColor: '#d33'
    });
    } finally {
      this.loading = false;
    }
  },
    // 🔹 New function added here
    toWords(amount) {
      var words = [];
      words[0] = '';
      words[1] = 'One';
      words[2] = 'Two';
      words[3] = 'Three';
      words[4] = 'Four';
      words[5] = 'Five';
      words[6] = 'Six';
      words[7] = 'Seven';
      words[8] = 'Eight';
      words[9] = 'Nine';
      words[10] = 'Ten';
      words[11] = 'Eleven';
      words[12] = 'Twelve';
      words[13] = 'Thirteen';
      words[14] = 'Fourteen';
      words[15] = 'Fifteen';
      words[16] = 'Sixteen';
      words[17] = 'Seventeen';
      words[18] = 'Eighteen';
      words[19] = 'Nineteen';
      words[20] = 'Twenty';
      words[30] = 'Thirty';
      words[40] = 'Forty';
      words[50] = 'Fifty';
      words[60] = 'Sixty';
      words[70] = 'Seventy';
      words[80] = 'Eighty';
      words[90] = 'Ninety';

      amount = amount.toString();
      var atemp = amount.split(".");
      var number = atemp[0].split(",").join("");
      var n_length = number.length;
      var words_string = "";

      if (n_length <= 9) {
        var n_array = new Array(0,0,0,0,0,0,0,0,0);
        var received_n_array = [];
        for (var i = 0; i < n_length; i++) {
          received_n_array[i] = number.substr(i, 1);
        }
        for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
          n_array[i] = received_n_array[j];
        }
        for (var i = 0, j = 1; i < 9; i++, j++) {
          if (i == 0 || i == 2 || i == 4 || i == 7) {
            if (n_array[i] == 1) {
              n_array[j] = 10 + parseInt(n_array[j]);
              n_array[i] = 0;
            }
          }
        }
        var value = "";
        for (var i = 0; i < 9; i++) {
          if (i == 0 || i == 2 || i == 4 || i == 7) {
            value = n_array[i] * 10;
          } else {
            value = n_array[i];
          }
          if (value != 0) {
            words_string += words[value] + " ";
          }
          if ((i == 1 && value != 0) || (i == 0 && value != 0 && n_array[i + 1] == 0)) {
            words_string += "Crores ";
          }
          if ((i == 3 && value != 0) || (i == 2 && value != 0 && n_array[i + 1] == 0)) {
            words_string += "Lakhs ";
          }
          if ((i == 5 && value != 0) || (i == 4 && value != 0 && n_array[i + 1] == 0)) {
            words_string += "Thousand ";
          }
          if (i == 6 && value != 0 && (n_array[i + 1] != 0 && n_array[i + 2] != 0)) {
            words_string += "Hundred and ";
          } else if (i == 6 && value != 0) {
            words_string += "Hundred ";
          }
        }
        words_string = words_string.split("  ").join(" ");
      } else {
        var coreunit = amount.substring(0, (amount.length - 7));
        var coreunit_e = parseFloat(amount.substring((amount.length - 7)));
        words_string = this.toWords(coreunit) + ' Crores';
        if (coreunit_e && coreunit_e > 0) {
          words_string += " " + this.toWords(coreunit_e);
        }
      }
      return words_string;
    },
    formatNumber(value) {
  if (value === null || value === undefined || value === '') return '-';
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
}

  }
}

</script>

<style scoped>
.card {
  transition: transform 0.2s;
}
.card:hover {
  transform: translateY(-2px);
}
</style>
